module.exports = __webpack_public_path__ + "static/media/accout-desktop.d52564a8.png";